import React from 'react';
import DashboardLayout from "../../layouts/DashboardLayout";

function Subscription() {
	return (
		<DashboardLayout>
			Subscription
		</DashboardLayout>
	);
}

export default Subscription;

